import { c as _c } from "react/compiler-runtime";
import React from "react";
import { chakra, Alert } from "@chakra-ui/react";
import { IoIosWarning } from "react-icons/io";
interface AlertInfoProps {
  message: string;
}
const AlertInfo: React.FC<AlertInfoProps> = t0 => {
  const $ = _c(3);
  const {
    message
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Alert.Indicator><IoIosWarning /></Alert.Indicator>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== message) {
    t2 = <Alert.Root status="error">{t1}<Alert.Title>{message}</Alert.Title></Alert.Root>;
    $[1] = message;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const AlertInfoChakra = chakra(AlertInfo);
export default AlertInfoChakra;